import { useQuery } from '@tanstack/react-query'
import { rolePermissionsApi, RolePermissionsResponse, PermissionKey } from '@/lib/api'
import { useAuth } from '@/contexts/AuthContext'
import api from '@/lib/api'

export function useRolePermissions() {
  const { user } = useAuth()
  const isAdmin = user?.role === 'super_admin' || user?.role === 'admin'

  const query = useQuery<RolePermissionsResponse>({
    queryKey: ['role-permissions'],
    queryFn: () => rolePermissionsApi.get(),
    enabled: isAdmin,
    staleTime: 60000,
  })

  return query
}

export function useMyPermissions() {
  const { user } = useAuth()

  const query = useQuery<{ permissions: Record<PermissionKey, boolean>; role: string }>({
    queryKey: ['my-permissions', user?.role],
    queryFn: () => api.get('/role-permissions/current').then(r => r.data),
    enabled: !!user,
    staleTime: 120000,
  })

  const canDo = (key: PermissionKey): boolean => {
    if (!query.data) return false
    return query.data.permissions[key] === true
  }

  return { ...query, canDo }
}
